import { c as _c } from "react/compiler-runtime";
import LogoutIcon from '@mui/icons-material/Logout';
export const Logout = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LogoutIcon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};